import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../hooks/useAuth";
import AccountMenu from "../AccountMenu";
import LanguageSwitcher from "../LanguageSwitcher";

const navItems = [
  { to: "/dashboard/download", labelKey: "nav.download" },
  { to: "/dashboard", labelKey: "nav.licences", end: true },
  { to: "/dashboard/invoices", labelKey: "nav.invoices" },
  { to: "/dashboard/settings", labelKey: "nav.profile" },
];

export default function DashboardLayout() {
  const { user } = useAuth();
  const { t } = useTranslation("dashboard");

  return (
    <div className="min-h-screen bg-[#050505]">
      <header className="border-b border-white/10 bg-[#0a0a0c]">
        <div className="max-w-[1360px] mx-auto px-4 md:px-7 h-[76px] flex items-center justify-between">
          <NavLink to="/" className="block">
            <img src="/voleor-logo.png" alt="Voleor" className="h-[27px] w-auto" />
          </NavLink>
          <div className="flex items-center gap-4">
            {user?.role === "admin" && (
              <NavLink to="/admin" className="text-xs text-[#FF5500] hover:text-[#FF7733]">{t("nav.admin")}</NavLink>
            )}
            <AccountMenu />
          </div>
        </div>
      </header>
      <div className="max-w-[1360px] mx-auto px-4 md:px-7 py-6 md:py-8 flex flex-col md:flex-row gap-6 md:gap-8">
        {/* Sidebar on desktop, scrollable tab strip on mobile: a fixed w-48 column
            left barely 110px for the content on a 390px screen. */}
        <nav className="w-full md:w-48 shrink-0">
          <ul className="flex gap-1 overflow-x-auto -mx-4 px-4 md:mx-0 md:px-0 md:block md:space-y-1">
            {navItems.map((item) => (
              <li key={item.to} className="shrink-0">
                <NavLink to={item.to} end={item.end}
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded text-sm whitespace-nowrap transition-colors ${isActive ? "bg-[#FF5500]/10 text-[#FF5500]" : "text-[#A1A1AA] hover:text-white hover:bg-white/5"}`
                  }>{t(item.labelKey)}</NavLink>
              </li>
            ))}
          </ul>
          <div className="mt-4 md:mt-6 md:px-4">
            <LanguageSwitcher />
          </div>
        </nav>
        <main className="flex-1 min-w-0"><Outlet /></main>
      </div>
    </div>
  );
}
